module.exports = __webpack_public_path__ + "static/WEDDING E&M-513-97e70ca6303ff7f2aefde51fe55a2de8.jpg";